module.exports = __webpack_public_path__ + "img/ANC.f821caa2.svg";